module.exports = __webpack_public_path__ + "static/media/importFlybook1.8ac707f1.png";